module.exports = __webpack_public_path__ + "9c0063804304a0941677593d5e7ee9a5.pdf";